import { render, staticRenderFns } from "./VP.vue?vue&type=template&id=cd0753b4&"
import script from "./VP.vue?vue&type=script&lang=js&"
export * from "./VP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports